export default class Darkmode {
  /**
   * 
   * @param {Boolean} storage - allow save state into localStorage
   */
  constructor (params) {
    this.storage = params.storage

    // init object
    document.addEventListener('DOMContentLoaded', () => (
      this.init()
    ))
  }

  init () {
    if(this.storage === true && this.getSavedState() == 'true') {
      this.toggle(true)
    }
  }

  /**
   * @desc Toggle darkmode to body
   */
  toggle (force = false) {
    // toggle class to body, if force, just add class
    if(force) {
      document.body.classList.toggle('darkmode', true)
    } else {
      document.body.classList.toggle('darkmode')
    }

    if(this.storage === true) {
      // save stage into localStorage
      this.saveState();
    }
  }

  /**
   * @desc return if body is on darkmode
   * @return {Boolean}
   */
  isDarkmode () {
    return document.body.classList.contains('darkmode')
  }

  /**
   * @desc save state in localStorage
   */
  saveState () {
    localStorage.setItem('darkmode', this.isDarkmode())
  }


 
  /**
   * @desc get localStorage state
   * @return {Boolean}
   */
  getSavedState () {
    if(localStorage.getItem('darkmode')) {
      return localStorage.getItem('darkmode')
    }
  }


}